// extracted by mini-css-extract-plugin
export default {"header":"mjpv0tgaTZgVsRh_ls8g"};